import { render, staticRenderFns } from "./UpdateGroup.vue?vue&type=template&id=1b6788ed&scoped=true"
import script from "./UpdateGroup.vue?vue&type=script&lang=js"
export * from "./UpdateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6788ed",
  null
  
)

export default component.exports